import { useQuery } from "@tanstack/react-query";
import { fetchAuditLog } from "@/api/reports";
import { downloadFile } from "@/api/download";
import { Button, Card, Skeleton } from "@/components";
import { toast } from "@/state/toast.store";
import { useLang } from "@/i18n/LanguageContext";
import { actionLabel as toActionLabel, auditSummary as summary } from "./auditLabels";

export function AuditLogPage() {
  const { t } = useLang();
  const audit = useQuery({ queryKey: ["audit-log"], queryFn: ({ signal }) => fetchAuditLog(200, signal) });
  const actionLabel = (a: string) => toActionLabel(a, t);

  async function download(path: string, name: string) {
    try {
      await downloadFile(path, name);
    } catch (e) {
      toast.err(e instanceof Error ? e.message : t("Download mislukt", "Download failed"));
    }
  }

  return (
    <section>
      <div className="wrap">
        <div className="toolbar">
          <div>
            <p className="eyebrow">Compliance</p>
            <h2 style={{ fontSize: 30 }}>{t("Audit-log", "Audit log")}</h2>
          </div>
          <div className="spacer" />
          <Button variant="outline" onClick={() => download("/api/reports/audit.csv", "audit-log.csv")}>{t("Export CSV", "Export CSV")}</Button>
          <Button variant="outline" onClick={() => download("/api/tenants/current/export", "onboardforge-export.json")}>{t("Data-export (AVG)", "Data export (GDPR)")}</Button>
        </div>

        <Card>
          {audit.isLoading ? (
            <Skeleton lines={6} />
          ) : audit.data && audit.data.length > 0 ? (
            <table className="data-table">
              <thead>
                <tr><th>{t("Tijd", "Time")}</th><th>{t("Actie", "Action")}</th><th>{t("Door", "By")}</th><th>{t("Object", "Object")}</th><th>{t("Details", "Details")}</th></tr>
              </thead>
              <tbody>
                {audit.data.map((e) => (
                  <tr key={e.id}>
                    <td className="ef-mono" style={{ whiteSpace: "nowrap" }}>{new Date(e.created_at).toLocaleString()}</td>
                    <td>{actionLabel(e.action)}</td>
                    <td>{e.actor_name ?? "—"}</td>
                    <td style={{ color: "var(--grey-text)" }}>{e.entity ?? ""}</td>
                    <td style={{ color: "var(--grey-text)", fontSize: 13 }}>{summary(e)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="no-data-message">{t("Nog geen gebeurtenissen.", "No events yet.")}</p>
          )}
        </Card>
      </div>
    </section>
  );
}
